import createAsyncReducer from '@/store/createAsyncReducer.js';
import Fetch from "~/functions/Fetch.js";
import { standardReducer } from "@/store/utils.js";

const accessKeysReducer = createAsyncReducer({
  name: 'accessKeys',
  initialState: {
    records: {},
    loading: false,
    errorMessage: ''
  },
  reducers: (create) => ({
    loadAll: create.asyncThunk(
      async () => {
        return Fetch.get(Routes.ajax_access_keys_path());
      },
      standardReducer
    ),
    loadOne: create.asyncThunk(
      async ({ code }) => {
        return Fetch.get(Routes.ajax_access_key_path(code))
      },
      standardReducer
    ),
    claim: create.asyncThunk(
      async ({ id }) => {
        return Fetch.patch(Routes.ajax_access_key_claim_path(id));
      },
      standardReducer
    )
  })
});

export default accessKeysReducer;